/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forCart } from "./constants";

const CancelToken = axios.CancelToken;

export let cancelGetOrdersApi;
export async function getOders(token, query = "") {
    if (token) {
        const orders = await axios.get(apiUrl_forCart + "order?" + query, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetOrdersApi = c;
            }),
        });
        return orders;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelAddCartApi;
export async function createOrder(token, orderData) {
    if ((token, orderData)) {
        const order = await axios.post(
            apiUrl_forCart + "create/order",
            orderData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCartApi = c;
                }),
            }
        );
        return order;
    } else {
        console.log("Please add required parameters");
    }
}
